import InputNumber from './InputNumber';
import InputNumberCompact from './InputNumberCompact';
var OSUIInputNumber = InputNumber;
OSUIInputNumber.InputNumberCompact = InputNumberCompact;
export default OSUIInputNumber;
//# sourceMappingURL=index.js.map